// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__GTXx+","content":"styles_content__B6VT1","description":"styles_description__XST7U","buttons":"styles_buttons__j1+qg"};